<template>
    <div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col order-xl-1">
                    <div class="card shadow">
                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col-md-10">
                                    <h3><i class="fa fa-file"></i> N° {{ one.refnum }}: {{ one.asunto }}</h3>
                                </div>
                                <div class="col-md-2">
                                    <div class="col text-right">
                                        <base-button type="danger" size="sm" @click="$router.push({ path: '/miscasos' })"><i class="fa fa-arrow-left"></i></base-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <template>
                                <form @submit.prevent>
                                    <div class="pl-lg-4">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input alternative="" label="Producto" input-classes="form-control-alternative" readonly v-model="one.idproductodesc"/>
                                            </div>
                                            <div class="col-lg-6">
                                                <base-input alternative="" label="Motivo" input-classes="form-control-alternative" readonly v-model="one.idtipodesc"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <base-input alternative="" label="Submotivo" input-classes="form-control-alternative" readonly v-model="one.idsubtipodesc"/>
                                            </div>
                                            <div class="col-lg-6">
                                                <base-input alternative="" label="Cuenta" input-classes="form-control-alternative" readonly v-model="one.idcuentadesc"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <base-input alternative="" label="Asunto" input-classes="form-control-alternative" readonly v-model="one.asunto"/>
                                            </div>
                                        </div>
                                    </div>
                                    <hr class="my-4" />
                                    <div class="pl-lg-4">
                                        <tabs fill class="flex-column flex-md-row">
                                            <card shadow>
                                                <tab-pane>
                                                    <span slot="title"><i class="fa fa-file"></i> Notas</span>
                                                    <notas tipoobjeto="casos" :idobjeto="id" :readonly="this.one"></notas>
                                                </tab-pane>

                                                <tab-pane>
                                                    <span slot="title"><i class="fa fa-paperclip"></i> Archivos</span>
                                                    <archivos-multiples tipoobjeto="casos" :idobjeto="id" :readonly="this.one"></archivos-multiples>
                                                </tab-pane>
                                            </card>
                                        </tabs>
                                    </div>
                                </form>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>

</style>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    components: {
      notas: () => import('@/components/Notas'),
      archivosMultiples: () => import('@/components/ArchivosMultiples')
    },
    computed: {
        ...mapGetters('casos',['one']),
        id(){
            return this.$route.params.id
        }
    },
    methods:{
        ...mapActions('casos',{ getCaso: 'getOne'}),
        getAll(){
            Promise.all([
                this.getCaso({ id: this.id }),
            ])
        }
    },
    mounted(){
        this.getAll()
    }
}
</script>
